import { useNavigate } from 'react-router-dom'
import { useIdleTimer } from 'react-idle-timer'
import { useEffect, useRef } from 'react'

const IdleTimer = (props: { timeout: number; startDateTime: Date; endDateTime: Date }) => {
  const navigate = useNavigate()
  const hasStarted = useRef(false)

  const onIdle = () => {
    navigate('/logout')
  }

  const { getRemainingTime, start, pause } = useIdleTimer({
    onIdle,
    timeout: props.timeout * 1000,
    startManually: true,
  })

  useEffect(() => {
    const checkTime = () => {
      console.log('check timer idle')
      const now = new Date()
      console.log('now', now)
      console.log('start', props.startDateTime)
      console.log('end', props.endDateTime)

      if (now >= props.startDateTime && now <= props.endDateTime) {
        if (!hasStarted.current) {
          console.log('start timer idle')
          hasStarted.current = true
          start()
        }
      } else {
        if (hasStarted.current) {
          console.log('pause timer idle')
          hasStarted.current = false
          pause()
        }
      }
    }

    // Check immediately
    checkTime()

    // Check every minute
    const interval = setInterval(checkTime, 60_000)

    return () => clearInterval(interval)
  }, [])

  return <></>
}

export default IdleTimer
